/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneCircleBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-5.446-4.38c-.232-.23-.689-.357-.955-.163-.427.31-1.05.786-1.441 1.176l-1.13 1.13-5.627-.984a.285.285 0 0 0-.25.08l-.41.41a.282.282 0 0 0 .086.46l4.357 1.877-2.05 2.052-1.334-.44a.284.284 0 0 0-.29.069l-.422.421a.283.283 0 0 0 .053.443l1.78 1.102 1.093 1.771a.283.283 0 0 0 .443.053l.421-.422a.284.284 0 0 0 .07-.29l-.44-1.333 2.05-2.051 1.879 4.357a.282.282 0 0 0 .46.086l.41-.41a.285.285 0 0 0 .079-.25l-.984-5.627 1.13-1.13c.39-.39.866-1.014 1.176-1.44.194-.267.077-.715-.154-.947Z" /></svg>);
const AirplaneCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneCircleBase} {...rest} ref={ref} />);
export default AirplaneCircle;